/**
 * ============================================================================
 * MASTER SERVICE: Menus & Navigation Service (`tbl_menus` - Sheet 13)
 * ============================================================================
 * Purpose:
 *   Handles API requests for dynamic menu hierarchies, drag-and-drop order updates,
 *   parent-child relationships, and role-based menu filtering.
 *
 * Database Scope:
 *   Master Database (`digimaster`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const baseMenuService = createCrudService("menus");

const menuService = {
  ...baseMenuService,

  /**
   * Retrieves full menu hierarchy tree with nested submenus.
   *
   * @returns {Promise<Object>} List of root menus with nested submenu arrays
   */
  getMenuTree: () => {
    return api.get("/menus/tree/all");
  },

  /**
   * Retrieves only root parent menus (int_parent_menu_id === 0).
   *
   * @returns {Promise<Object>} Root menu list
   */
  getParents: () => {
    return api.get("/menus/parents");
  },

  /**
   * Retrieves menu hierarchy authorized for a specific role ID.
   *
   * @param {number} roleId
   * @returns {Promise<Object>} Filtered menu tree
   */
  getMenusByRole: (roleId) => {
    return api.get(`/menus/by-role/${roleId}`);
  },

  /**
   * Bulk updates display order and parent IDs of menus.
   *
   * @param {Array<{ int_menu_id: number, int_order: number, int_parent_menu_id?: number }>} items
   * @returns {Promise<Object>} Reorder confirmation
   */
  reorder: (items) => {
    return api.post("/menus/reorder", { items });
  },
};

export default menuService;
